import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterName",
})
/**
 *
 * This pipe filter generic list item by predicate (search text), field (optional, default by field name) and also by extra field which is optional
 * It could be called directly in ngFor costrucor as "ngFor="let element of lists | filterName:searchPredicate""" or
 * "ngFor="let element of lists | filterName:searchPredicate:'description' : 'extraFieldHere'" (es. if i wand filter by description field of single object)
 *
 */
export class FilterNamePipe implements PipeTransform {
  transform(
    items: Array<any>,
    predicate: string,
    field?: string,
    extraField?: string
  ): any {
    if (!field) {
      field = "name";
    }

    if (predicate.length >= 2) {
      return items.filter((item) => {
        const fieldValue = item[field] as string;
        const extraFieldValue = item[extraField] as string;

        if (
          fieldValue &&
          fieldValue.toUpperCase().includes(predicate.toUpperCase())
        ) {
          return true;
        }

        if (
          extraField &&
          extraFieldValue &&
          extraFieldValue.toUpperCase().includes(predicate.toUpperCase())
        ) {
          return true;
        }

        return false;
      });
    } else {
      return items;
    }
  }
}
